import React, { useContext } from "react";
import { packClasses } from "Utils";
import { Transition, Menu } from "@headlessui/react";
import { ChevronRightIcon } from "@heroicons/react/solid";

const ToolbarContext = React.createContext({ nesting: false });

function ToolbarMenu(props) {
    const icon = props.icon ? props.icon : null;

    const { nesting } = useContext(ToolbarContext);

    return (
        <Menu
            as="div"
            className={packClasses(
                !nesting ? "relative" : "",
                "inline-block text-left"
            )}
        >
            <Menu.Button
                className={packClasses(
                    "hover:bg-gray-100 hover:text-gray-900",
                    "disabled:bg-white disabled:text-gray-800 disabled:opacity-50",
                    "relative flex items-center rounded px-3 py-2 text-sm text-gray-800 lg:px-4",
                    props.className ? props.className : ""
                )}
                disabled={props.disabled}
            >
                {icon
                    ? React.cloneElement(icon, {
                          className: "h-4 w-4 mr-1",
                      })
                    : ""}
                <span className={icon ? "hidden md:flex" : ""}>
                    {props.label}
                </span>
            </Menu.Button>
            <Transition
                enter="transition duration-100 ease-out"
                enterFrom="transform scale-95 opacity-0"
                enterTo="transform scale-100 opacity-100"
                leave="transition duration-75 ease-out"
                leaveFrom="transform scale-100 opacity-100"
                leaveTo="transform scale-95 opacity-0"
            >
                {props.children}
            </Transition>
        </Menu>
    );
}

export default ToolbarMenu;

export const ToolbarMenuItems = ({ children, className, ...remainder }) => {
    const { nesting } = useContext(ToolbarContext);

    return (
        <Menu.Items
            className={packClasses(
                nesting ? "left-full top-full md:absolute" : "absolute left-0",
                "focus:outline-none  mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5",
                className
            )}
            {...remainder}
        >
            {children}
        </Menu.Items>
    );
};

export const ToolbarMenuItem = ({ children, className, ...remainder }) => {
    return (
        <Menu.Item>
            {({ active }) => (
                <div
                    {...remainder}
                    className={packClasses(
                        active ? "bg-gray-100 text-gray-900" : "text-gray-700",
                        "block cursor-pointer px-4 py-2 text-sm",
                        className
                    )}
                >
                    {children}
                </div>
            )}
        </Menu.Item>
    );
};

export const ToolbarSubMenu = (props) => {
    const icon = props.icon ? props.icon : null;
    const { nesting } = useContext(ToolbarContext);

    return (
        <Menu
            as="div"
            className={packClasses(
                !nesting ? "relative" : "",
                " block text-left"
            )}
        >
            <Menu.Button
                className={packClasses(
                    "disabled:bg-white disabled:text-gray-800 disabled:opacity-50",
                    "flex cursor-pointer items-center text-sm text-gray-800"
                )}
                disabled={props.disabled}
                as="div"
            >
                {icon
                    ? React.cloneElement(icon, {
                          className: "h-4 w-4 mr-1",
                      })
                    : ""}
                <span className={icon ? "hidden md:flex" : "grow"}>
                    {props.label}
                </span>
                <ChevronRightIcon className="ml-auto h-4 w-4" />
            </Menu.Button>
            <Transition
                enter="transition duration-100 ease-out"
                enterFrom="transform scale-95 opacity-0"
                enterTo="transform scale-100 opacity-100"
                leave="transition duration-75 ease-out"
                leaveFrom="transform scale-100 opacity-100"
                leaveTo="transform scale-95 opacity-0"
            >
                <ToolbarContext.Provider value={{ nesting: true }}>
                    {props.children}
                </ToolbarContext.Provider>
            </Transition>
        </Menu>
    );
};
